import { Loader } from '../../components';
import { memo, useEffect } from 'react';
import { useActiveLoan } from '../ActiveLoan/useActiveLoan';
import { useApplication, useLatestLoan } from '../../hooks/webapi';
import ExtensionsNotOverdue from './ExtensionsNotOverdue';
import ExtensionsOverdue from './ExtensionsOverdue';

// @TODO: refactor the whole screen
export default memo(function Extensions() {
  const { isOverdue } = useActiveLoan();
  const { application, fetchApplication } = useApplication();
  const { latestLoan, fetchLatestLoan } = useLatestLoan();

  useEffect(() => {
    const prefetch = async () => {
      try {
        await fetchLatestLoan();
        await fetchApplication();
      } catch {}
    };

    prefetch();
  }, [fetchApplication, fetchLatestLoan]);

  if (!application || !latestLoan) return <Loader />;

  if (isOverdue) return <ExtensionsOverdue />;

  return <ExtensionsNotOverdue />;
});
